import { render, staticRenderFns } from "./AttachScanCopy.vue?vue&type=template&id=08b582ab&"
import script from "./AttachScanCopy.vue?vue&type=script&lang=js&"
export * from "./AttachScanCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports